import axios from "@/axios"

const url = "/api/brain/preparation/incidences"

class PreparationIncidencesService {
	async getIncidences(params) {
		try {
			const { data } = await axios.get(`${url}`, { params })
			return data
		} catch (error) {
			throw error
		}
	}

	async storeIncidence(params) {
		try {
			const { data } = await axios.post(`${url}`, params)
			return data
		} catch (error) {
			throw error
		}
	}

	async switchActive(id) {
		try {
			const { data } = await axios.put(`${url}/switch-active/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}

	async updateIncidence(id, params) {
		try {
			const { data } = await axios.put(`${url}/${id}`, params)
			return data
		} catch (error) {
			throw error
		}
	}

	async deleteIncidence(id) {
		try {
			const { data } = await axios.delete(`${url}/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new PreparationIncidencesService()
